import { MemberTaskList } from '@dialogue/silkroad'

import { logger } from 'APP/Lib/Datadog'
import { SUPPORTED_MEMBER_TASK_TYPES } from './config'
import type { MemberTask } from './types'

/**
 * Keep only the Member Tasks the app explicitly supports (see `SUPPORTED_MEMBER_TASK_TYPES`),
 * filtering out unknown tasks at runtime (to avoid issues with future tasks added to Silkroad).
 */
export const keepSupportedTasksOnly = (list: MemberTaskList): MemberTask[] =>
  (list.next_tasks ?? []).filter((task): task is MemberTask => {
    if (SUPPORTED_MEMBER_TASK_TYPES.includes(task?.task_experience)) return true

    logger.warn('Skipping unsupported next task', {
      taskName: task?.task_experience,
    })

    return false
  })
